<template>
  <!-- 商品佣金设置 -->
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            商品名称：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.item_name"
              placeholder="请输入商品名称"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            货号：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.item_bn"
              placeholder="请输入货号"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </div>
    </div>

    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="importVisible = true"
      >
        批量导入
      </el-button>
      <el-button
        type="primary"
        plain
        @click="refreshGoods"
      >
        同步更新
      </el-button>
    </div>

    <div class="f-table-block">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods">
              <div class="goods-image">
                <img
                  :src="scope.row.pic"
                  alt=""
                  srcset=""
                >
              </div>
              <div class="goods-info">
                <div class="goods-name">
                  {{ scope.row.item_name }}
                </div>
                <div>货号：{{ scope.row.item_bn }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="salesperson_status"
          label="开启提成"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.profit.sale_commission.open_profit">
              云店提成：{{ scope.row.sale_count }}
            </div>
            <div v-if="scope.row.profit.bind_commission.open_profit">
              绑定提成：{{ scope.row.bind_count }}
            </div>
            <!-- <div v-if="scope.row.profit.offline_commission.open_profit">
              开单提成：{{ scope.row.offline_count }}
            </div> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="sku"
          label="商品规格"
          width="120"
        />
        <el-table-column
          label="价格"
          width="120"
          align="right"
        >
          <template slot-scope="scope">
            <span>￥{{ scope.row.item_price / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          show-overflow-tooltip
        />
        <el-table-column
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="setCommission(scope.row)"
            >
              设置佣金
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 设置分佣的抽屉 -->
    <el-drawer
      :visible.sync="showDrawer"
      direction="rtl"
      size="50%"
    >
      <div
        slot="title"
        class="drawer-title"
      >
        商品佣金设置
      </div>
      <div class="drawer-box">
        <div class="goods">
          <div class="goods-image">
            <img
              :src="drawerInfo.pic"
              alt=""
              srcset=""
            >
          </div>
          <div class="goods-info">
            <div class="goods-name">
              {{ drawerInfo.item_name }}
            </div>
            <div>
              <span>货号：{{ drawerInfo.item_bn }}</span>
              <span
                class="drawer-price"
              >销售价：<span class="drawer-money">¥ {{ drawerInfo.item_price / 100 }}</span></span>
            </div>
          </div>
        </div>

        <el-table :data="drawerTableData">
          <el-table-column
            label="提成类型"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.profit_type == 1">云店销售提成</span>
              <span v-if="scope.row.profit_type == 2">绑定会员提成</span>
              <span v-if="scope.row.profit_type == 3">门店开单提成</span>
            </template>
          </el-table-column>
          <el-table-column
            label="开启提成"
            width="100"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.open_profit"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
              />
            </template>
          </el-table-column>
          <el-table-column label="提成计算类型">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.profit_calculation_type"
                placeholder="请选择"
                :disabled="scope.row.open_profit === 0"
                @change="(value) => selectChange(value, scope.row)"
              >
                <el-option
                  label="按默认"
                  :value="0"
                />
                <el-option
                  label="比例"
                  :value="1"
                />
                <el-option
                  label="金额"
                  :value="2"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="佣金">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.profit"
                placeholder="请输入内容"
                class="input-m input-with-select"
                :disabled="scope.row.profit_calculation_type == 0 || scope.row.open_profit === 0"
              >
                <span slot="append">{{ scope.row.profit_calculation_type == 1 ? '%' : '元' }}</span>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          class="drawer-button"
          :loading="submitSaveLoading"
          type="primary"
          @click="submitSave"
        >
          保存
        </el-button>
      </div>
    </el-drawer>

    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="items_profit"
      title="批量导入佣金"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明：<br>
        1、导出商品佣金设置文件，导出成功后下载文件<br>
        2、根据填写要求填写商品规格佣金信息，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000，超出请按文件分批上传<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>
  </div>
</template>

<script>
import { getGoodsList, getGoodsProfit, setGoodsProfit } from '@/api/relationship/goodsCommission'
export default {
  data () {
    return {
      params: {
        page: 1,
        page_size: 20,
        item_name: '',
        item_bn: ''
      },
      total_count: 0, //列表总个数
      tableData: [], //商品表格数据
      loading: false,
      multipleSelection: [], //全选选中数据
      showDrawer: false, //展示设置分佣
      gridData: [],
      drawerInfo: {},
      drawerTableData: [],
      importVisible: false,
      submitSaveLoading: false
    }
  },
  mounted () {
    this.getList('getFirst')
  },
  methods: {
    // 获取列表数据
    async getList (type) {
      this.loading = true
      const data = await getGoodsList(this.params)
      if (data) {
        if (data.total_count < 1 && type === 'getFirst') {
          this.refreshGoods('first')
        }
        data.list.map((v) => {
          v.sale_count =
            v.profit.sale_commission.profit_calculation_type === 1
              ? v.profit.sale_commission.profit + '%'
              : v.profit.sale_commission.profit_calculation_type === 2
              ? v.profit.sale_commission.profit / 100 + '元'
              : v.profit.sale_commission.profit
          v.bind_count =
            v.profit.bind_commission.profit_calculation_type === 1
              ? v.profit.bind_commission.profit + '%'
              : v.profit.bind_commission.profit_calculation_type === 2
              ? v.profit.bind_commission.profit / 100 + '元'
              : v.profit.bind_commission.profit
          v.offline_count =
            v.profit.offline_commission.profit_calculation_type === 1
              ? v.profit.offline_commission.profit + '%'
              : v.profit.offline_commission.profit_calculation_type === 2
              ? v.profit.offline_commission.profit / 100 + '元'
              : v.profit.offline_commission.profit
        })
        this.tableData = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },

    // 获取导购分佣配置
    async getGoodsProfit (row) {
      let item_id = row.item_id
      const data = await getGoodsProfit(item_id, { item_id })
      if (data) {
        // let newArr = [data.sale_commission, data.bind_commission, data.offline_commission]
        let newArr = [data.sale_commission, data.bind_commission]
        newArr.map((v) => {
          if (v.profit_calculation_type === 2) {
            // 金额获取的是分
            v.profit = v.profit / 100
          }
        })
        this.drawerTableData = newArr
      }
    },

    // 更新数据
    haddleRefresh () {},

    // 列表多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    // 设置佣金
    setCommission (row) {
      this.showDrawer = true
      this.drawerInfo = row
      this.getGoodsProfit(row)
    },
    // 保存佣金设置
    async submitSave () {
      this.submitSaveLoading = true
      const data = await setGoodsProfit(this.drawerInfo.item_id, this.drawerTableData).catch(() => {
        this.submitSaveLoading = false
      })
      if (data) {
        this.submitSaveLoading = false
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.showDrawer = false
        this.getList()
      }
    },

    // 查询列表
    searchList () {
      this.params.page = 1
      this.getList()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 确定导入
    saveImportAction () {
      this.params.page = 1
      this.getList()
    },

    // 勾选默认置0
    selectChange (value, row) {
      if (value === 0) {
        row.profit = 0
      }
    },

    // 同步更新商品
    async refreshGoods (type) {
      const data = await this.$api.component.refreshGoods()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.goods {
  display: flex;
  margin-bottom: 20px;
  .goods-image {
    width: 80px;
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-info {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
    .goods-name {
      margin-bottom: 6px;
      line-height: 22px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

.drawer-title {
  font-size: 16px;
  color: #606266;
}
.drawer-box {
  padding: 20px;
  .drawer-button {
    margin-top: 40px;
  }
}
.drawer-price {
  margin-left: 50px;
  .drawer-money {
    color: #ff5000;
    font-weight: 650;
  }
}
.import-tips {
  color: #999999;
  font-size: 12px;
  line-height: 24px;
  margin-top: 25px;
}
.import-body {
  margin-top: -20px;
}

.importBtns {
  height: auto;
  position: relative;
}
.button-right {
  display: flex;
  align-items: center;
  position: absolute;
  left: 84px;
  top: 0;
  margin: auto;
}
</style>
